import React from 'react';
import { FaBolt, FaChartBar, FaChartLine, FaClipboardList, FaCog, FaHistory, FaHourglassHalf, FaMoneyBillWave } from 'react-icons/fa';
import Button from '@/components/UI/Button';

interface PortfolioActionsCardProps {
    portfolioId: number;
    onAllocateFunds: () => void;
}

const PortfolioActionsCard: React.FC<PortfolioActionsCardProps> = ({ portfolioId, onAllocateFunds }) => {
    return (
        <div className="grid grid-cols-12 gap-4 mt-4 mb-3">
            <div className="col-span-12">
                <div className="bg-[#1a1a1a] text-white rounded-lg shadow-md">
                    <div className="p-3">
                        <div className="flex justify-center">
                            <div className="flex flex-wrap gap-2 justify-center">
                                {/* Primary Actions */}
                                <Button icon={<FaMoneyBillWave aria-hidden="true" />} variant="primary" onClick={onAllocateFunds}>
                                    Allocate Funds
                                </Button>
                                <Button
                                    icon={<FaChartLine aria-hidden="true" />}
                                    to={`/user/portfolioBacktest/${portfolioId}`}
                                    variant="primary"
                                >
                                    Backtest
                                </Button>

                                {/* Settings & History */}
                                <Button
                                    icon={<FaCog aria-hidden="true" />}
                                    to={`/user/portfolioSettings/${portfolioId}`}
                                    variant="secondary"
                                >
                                    Settings
                                </Button>
                                <Button
                                    icon={<FaHistory aria-hidden="true" />}
                                    to={`/user/portfolioTradeHistory/${portfolioId}`}
                                    variant="secondary"
                                >
                                    Trade History
                                </Button>
                                <Button
                                    icon={<FaChartBar aria-hidden="true" />}
                                    to={`/user/portfolioPerformance/${portfolioId}`}
                                    variant="secondary"
                                >
                                    Performance
                                </Button>

                                {/* Monitoring & Trades */}
                                <Button
                                    icon={<FaClipboardList aria-hidden="true" />}
                                    to={`/user/entryLog/?portfolioId=${portfolioId}`}
                                    variant="secondary"
                                >
                                    Entry Log
                                </Button>
                                <Button
                                    icon={<FaBolt aria-hidden="true" />}
                                    to={`/user/realTimeEntries/?portfolioId=${portfolioId}`}
                                    variant="secondary"
                                >
                                    Real Time Entries
                                </Button>
                                <Button
                                    icon={<FaHourglassHalf aria-hidden="true" />}
                                    to={`/user/portfolioPendingTrades/${portfolioId}`}
                                    variant="secondary"
                                >
                                    Pending Trades
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortfolioActionsCard;
